import { gql } from '@apollo/client';

export const fetchAddOnsForEntitlement = gql`
  query fetchAddOnsForEntitlement($id: String, $searchOptions: ConnectionSearchOptions) {
    entitlementDetails(id: $id) {
      id
      addOns(searchOptions: $searchOptions) {
        totalCount
        edges {
          node {
            id
            entitlementNumber
            dateAdded
            units
            name
            nextBillDate
            dateRemoved
            dateLastBilled
            billingStatus
            provisioningStatus
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
